/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.Email = class Email {
  constructor(el, controller) {
    this._formSubmitted = this._formSubmitted.bind(this);
    this.el = el;
    this.controller = controller;
    this.recipientList = this.el.find("[data-recipient-list]");
    this.button = this.el.find("button");
    this.pb = new Buyapowa.Helpers.ProgressButton(this.button);

    this._setupTags();
    this._bindEvents();
  }

  getUrl() {
    return this.el.attr("action");
  }

  getData() {
    return this.el.serializeObject();
  }

  getCampaignId() {
    return this.el.data('campaign-id');
  }

  clearRecipients() {
    return this.tags.clear();
  }

  displayResult(result, message) {
    return this.pb.finished(result, message);
  }

  allowSubmit(bool) {
    if (!bool) {
      return this.button.attr("disabled", "disabled");
    } else {
      return this.button.removeAttr("disabled");
    }
  }

  _bindEvents() {
    return this.el.on("submit", this._formSubmitted);
  }

  _formSubmitted(e) {
    if (this.tags.tagCount() > 0) {
      this.controller.formSubmitted();
      this.pb.started();
    }

    e.preventDefault();
    return false;
  }

  _setupTags() {
    return this.tags = new Buyapowa.Views.Tags(this.recipientList, {
      validateTag: value => {
        if (!this.controller.validateEmail(value)) {
          return this.el.data("invalid-email-tooltip");
        }
      },
      tagsChanged: count => {
        return this.controller.emailsChanged(count);
      },

      validTagEntered: () => {
        return this.allowSubmit(true);
      },

      validTagNotEntered: () => {
        return this.allowSubmit(this.tags.tagCount() > 0);
      }
    }
    );
  }

  emailSentText() {
    return this.el.data("email-sent");
  }

  sendErrorText() {
    return this.el.data("send-error");
  }
};
